@if (modelLocator.menu.bottom) {
<ion-row slot="bottom" class="ion-hide-md-up" fixed>
    @for (item of menuFooter; track item.route) { @if (getCondition(item)) {
    <ion-col (click)="touchGoToRoute(item)">
        <ion-img [src]="item.icon"></ion-img>
        <ion-label>{{ item.label }}</ion-label>
    </ion-col>
    } }
</ion-row>
}
